import { loginApi } from '@/common/api/index.bak';
import { message } from 'antd';
import { getUrlParams } from '@/common/utils/utils.js';

export const dva = {
  config: {
    onError(err) {
      err.preventDefault();
      console.error(err.message);
    }
  }
};

// render方法调用前，先获取登录状态
export const render = oldRender => {
  // 已登陆存在token，未登录sid
  const AFF_TOKEN = localStorage.getItem('AFF_TOKEN');
  const sid = getUrlParams('sid');
  const gb = getUrlParams('v') === 'gb';

  if (!sid && !AFF_TOKEN) {
    if (gb) {
      oldRender();
    } else {
      let cUrl = "http://" + window.location.hostname + (window.location.port ? (":" + window.location.port) : "");
      loginApi({
        sid,
        wwUrl: cUrl
      }).then(res => {
        const { code, msg, data } = res.data;
        if (code === 0) {
          window.location.href = data.url
        } else {
          message.error(msg);
        }
        oldRender();
      });
    }
  }

  if (sid && !AFF_TOKEN) {
    loginApi({
      sid
    }).then(res => {
      const { code, msg, data } = res.data;
      if (code === 0) {
        const { token } = data;
        localStorage.setItem('AFF_TOKEN', token);
      } else {
        message.error(msg);
      }
      oldRender();
    });
  } else {
    oldRender();
  }
};
